/* eslint-disable */

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import axios from "axios";
import { convertLocalImageToBase64 } from '../../utils/imageUtils';

const PAGINA_ALTO = 595.28
const PAGINA_ANCHO = 841.89
const MARGEN_PAGINA = 30
const SEPARACION_COLUMNAS = 16
const ANCHO_COLUMNA = (PAGINA_ANCHO - MARGEN_PAGINA * 2 - SEPARACION_COLUMNAS) / 2
const INICIO_DERECHA = MARGEN_PAGINA + ANCHO_COLUMNA + SEPARACION_COLUMNAS
const ANCHO_SELLO = 110
const ALTO_SELLO = 36

function altoLinea(fontSize) {
    return fontSize * 1.15
}

function cantidadLineas(texto, ancho, fontSize) {
    const limpio = String(texto || '').trim()
    if (!limpio) return 1
    const porLinea = Math.max(8, Math.floor(ancho / (fontSize * 0.56)))
    return Math.max(1, Math.ceil(limpio.length / porLinea))
}

function calcularPosicionFirma(medicamentos, signosAlarma, cantidadCie, observaciones) {
    let alto = 0
    alto += 2 + altoLinea(11) + 4
    alto += 4 * (altoLinea(8) + 1)
    alto += 6 + altoLinea(9) + 3
    alto += 1 + 2.8
    alto += 20 + altoLinea(8)
    alto += altoLinea(8)
    alto += 1 + altoLinea(8)
    alto += Math.max(1, cantidadCie || 1) * (1 + altoLinea(8))
    alto += 1 + (signosAlarma ? altoLinea(8) : 0) + 20
    alto += altoLinea(12) + 20
    alto += 2 + altoLinea(9) + 2

    const anchoIndicaciones = ANCHO_COLUMNA * 0.5 - 4
    const anchoMedicamento = ANCHO_COLUMNA * 0.38 - 8
    const filas = Array.isArray(medicamentos) ? medicamentos : []
    filas.forEach((item, index) => {
        const lineas = Math.max(
            cantidadLineas(item && item.nombre, anchoMedicamento, 8),
            cantidadLineas(item && item.indicaciones, anchoIndicaciones, 8)
        )
        const margen = index < filas.length - 1 ? 8 : 0
        alto += 2 + lineas * altoLinea(8) + 2 + margen
    })

    const nota = String(observaciones || '').trim()
    if (nota) {
        const lineasNota = cantidadLineas(`Nota: ${nota}`, ANCHO_COLUMNA, 8)
        alto += 8 + lineasNota * altoLinea(8) + 8
    } else {
        alto += 8
    }

    const desdeArriba = MARGEN_PAGINA + alto + 6
    let posicionY = Math.round(PAGINA_ALTO - desdeArriba)
    const minimo = ALTO_SELLO + 80
    if (posicionY < minimo) posicionY = minimo

    const posicionX = Math.round(INICIO_DERECHA + ANCHO_COLUMNA - ANCHO_SELLO)
    return { x: posicionX, y: posicionY }
}

function listaCie10(cie10) {
    if (cie10 && Array.isArray(cie10.diagnosticos) && cie10.diagnosticos.length) {
        return cie10.diagnosticos
    }
    if (cie10 && cie10.codigo) {
        return [{ codigo: cie10.codigo, nombre: cie10.nombre }]
    }
    return []
}

function lineasCie10(cie10) {
    return listaCie10(cie10).map((item) => ({
        text: [
            { text: 'CIE - 10: ', bold: true },
            { text: `${item.codigo} - ${item.nombre}` }
        ],
        fontSize: 8,
        margin: [0, 1, 0, 0]
    }))
}

function textoFecha(fecha) {
    if (fecha && /^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
        const [anio, mes, dia] = fecha.split('-');
        return `${dia}/${mes}/${anio}`;
    }
    return new Date().toLocaleDateString('es-EC');
}

async function armarDefinicionReceta(pacientes, receta, edad, especialidad, cie10, signosAlarma, observaciones) {

    const imageUrl = await convertLocalImageToBase64('/img/certificados/padre.png');
    const footerImageUrl = await convertLocalImageToBase64('/img/certificados/footer-receta.png');
    //const watermarkImageUrl = await downloadImage('https://www.whatsivo.com/wp-content/uploads/2025/02/padre.png');

    const docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [30, 30, 30, 30],
        background: function (currentPage, pageSize) {
            const mitad = pageSize.width / 2;
            const anchoMarca = mitad * (400 / 595);
            return {
                image: imageUrl, // Imagen de fondo
                width: anchoMarca,
                absolutePosition: { x: mitad + (mitad - anchoMarca) / 2, y: (pageSize.height - anchoMarca) / 2 },
                opacity: 0.07 // Transparencia de la marca de agua
            };
        },

        content: [
            {
                columns: [
                    { width: '*', text: '' },
                    {
                        width: '*',
                        stack: [
            {
                image: imageUrl,
                width: 56,
                absolutePosition: { x: 429, y: 50 }
            },
            {
                alignment: 'center',
                margin: [0, 0, 0, 2],
                stack: [
                    { text: 'CENTRO DE ESPECIALIDADES PADRE EMILIO CATALÁN', style: 'header', noWrap: true },
                    {
                        text: [
                            { text: 'Dirección: ', bold: true },
                            { text: 'Pasaje e/ Bolivar y Sucre.' }
                        ],
                        style: 'subheader1'
                    },
                    { text: '(Junto a la Botica Comunitaria)', style: 'subheader1' },
                    { text: 'El Guabo - El Oro - Ecuador', style: 'subheader1' },
                    {
                        text: [
                            { text: 'Teléfono: ', bold: true },
                            { text: '07-2952-091' }
                        ],
                        style: 'subheader1'
                    }
                ]
            },
            {
                text: especialidad || '',
                style: 'subheader2'
            },
            generateLineaEncabezado(),
            {
                text: [
                    { text: 'Fecha: ', bold: true },
                    { text: textoFecha(pacientes.fecha) },
                ],
                alignment: 'right',
                fontSize: 8,
                margin: [0, 20, 0, 0]  // margin: [izquierda, arriba, derecha, abajo]
            },
            {
                columns: [
                    {
                        // Cédula alineada a la izquierda
                        text: [
                            { text: 'Cédula: ', bold: true },
                            { text: pacientes.cedula }
                        ],
                        fontSize: 8,
                        width: '*',
                    },
                    {
                        // Edad alineada a la derecha
                        text: [
                            { text: 'Edad: ', bold: true },
                            { text: edad }
                        ],
                        fontSize: 8,
                        alignment: 'right',
                        width: 'auto',
                    }
                ]
            },
            {
                // Nombres en una línea separada
                text: [
                    { text: 'Nombres: ', bold: true },
                    { text: pacientes.nombres }
                ],
                fontSize: 8,
                margin: [0, 1, 0, 0]
            },
            ...lineasCie10(cie10),
            {
                text: signosAlarma ? [
                    { text: 'Signos de alarma: ', bold: true },
                    { text: signosAlarma.toUpperCase() }
                ] : '',
                fontSize: 8,
                margin: [0, 1, 0, 20]
            },
            { text: 'RECETA MÉDICA', style: 'header2', margin: [0, 0, 0, 20] },
            generateTable(receta),
            {
                // si signos de alarma existe entonces se pone en la receta
                text: observaciones ? [
                    { text: 'Nota: ', bold: true },
                    { text: observaciones.toUpperCase() }
                ] : '',
                fontSize: 8,
                alignment: 'justify',
                margin: observaciones ? [0, 8, 0, 8] : [0, 8, 0, 0]
            },
                        ]
                    }
                ],
                columnGap: 16
            }
        ],



        footer: function (currentPage, pageCount, pageSize) {
            const anchoColumna = (pageSize.width / 2) - 40;
            const inicioDerecha = (pageSize.width / 2) + 8;
            return {
                image: footerImageUrl,
                width: anchoColumna,
                margin: [inicioDerecha, -65, 0, 0]
            };
        },
        styles: {
            header: { fontSize: 11, color: '#01365e', bold: true, alignment: 'center', margin: [0, 2, 0, 4] },
            header2: { fontSize: 12, color: '#01365e', bold: true, characterSpacing: 5, alignment: 'center', margin: [0, 0, 0, 10] },
            subheader1: { fontSize: 8, alignment: 'center', margin: [0, 0, 0, 1] },
            subheader2: { fontSize: 9, bold: true, alignment: 'center', margin: [0, 6, 0, 3], characterSpacing: 1.6, color: '#01365e' },
            section: { fontSize: 10, bold: true, margin: [0, 10, 0, 0] },
            content: { fontSize: 8, margin: [0, 1, 0, 2] }
        },
        defaultStyle: {
            fontSize: 9,
            columnGap: 10
        },
        pageBreakBefore: function (currentNode, followingNodesOnPage) {
            return currentNode.headlineLevel === 1 && followingNodesOnPage.length > 0;
        }
    };


    return {
        docDefinition,
        posicion: calcularPosicionFirma(receta, signosAlarma, listaCie10(cie10).length, observaciones)
    }
}

export const generatePdfReceta = async (pacientes, receta, edad, especialidad, cie10, signosAlarma, observaciones) => {
    const { docDefinition } = await armarDefinicionReceta(pacientes, receta, edad, especialidad, cie10, signosAlarma, observaciones)
    pdfMake.createPdf(docDefinition).open()
}

export const crearPdfRecetaFirmable = async (pacientes, receta, edad, especialidad, cie10, signosAlarma, observaciones) => {
    const { docDefinition, posicion } = await armarDefinicionReceta(pacientes, receta, edad, especialidad, cie10, signosAlarma, observaciones)
    const pdf = await new Promise((resolve, reject) => {
        try {
            pdfMake.createPdf(docDefinition).getBase64((data) => resolve(data))
        } catch (error) {
            reject(error)
        }
    })

    return {
        pdf,
        pagina: 1,
        posicionX: posicion.x,
        posicionY: posicion.y
    }
}

function generateLineaEncabezado() {
    return {
        margin: [0, 1, 0, 0],
        table: {
            widths: ['*'],
            body: [
                [
                    {
                        text: '',
                        fillColor: '#01365e',
                        border: [false, false, false, false]
                    }
                ]
            ]
        },
        layout: {
            hLineWidth: () => 0,
            vLineWidth: () => 0,
            paddingLeft: () => 0,
            paddingRight: () => 0,
            paddingTop: () => 1.4,
            paddingBottom: () => 1.4
        }
    };
}

function generateTable(datos) {
    return {
        table: {
            headerRows: 1,
            widths: ['12%', '38%', '50%'],
            body: [
                // Fila de encabezado
                [
                    { text: 'CANTIDAD', bold: true, fontSize: 9, color: '#01365e' },
                    { text: 'MEDICAMENTO', bold: true, fontSize: 9, color: '#01365e' },
                    { text: 'INDICACIONES', bold: true, fontSize: 9, color: '#01365e' }
                ],
                // Las filas de datos
                ...datos.map((item, index) => [
                    { text: item.cantidad, alignment: 'center', fontSize: 8 },
                    { text: item.nombre.toUpperCase(), fontSize: 8 },
                    {
                        text: item.indicaciones.toUpperCase(),
                        alignment: 'justify',
                        fontSize: 8,
                        margin: [0, 0, 0, index < datos.length - 1 ? 8 : 0]  // Agregar margen al final si no es el último elemento
                    }
                ])
            ]
        },
        layout: 'noBorders'
    };
}

async function downloadImage(url) {
    try {
        const response = await axios.get(url, { responseType: 'blob' });
        const blob = response.data;

        const imageUrl = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

        return imageUrl;
    } catch (error) {
        console.error('Error al descargar la imagen:', error);
        throw error;
    }
}



